import { render, staticRenderFns } from "./ResourcePagePlanCta.vue?vue&type=template&id=5966be98&scoped=true"
import script from "./ResourcePagePlanCta.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourcePagePlanCta.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ResourcePagePlanCta.vue?vue&type=style&index=0&id=5966be98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5966be98",
  null
  
)

export default component.exports